<div
  class="x_form-group"
  [class.x_form-group__row]="rowLayout"
  [ngClass]="className"
>
  @if (label) {
    <label class="x_label" [for]="name"
      >{{ label }}
      @if (required) {
        <span class="required">*</span>
      }
    </label>
  }
  <div
    class="x_input-group"
    [ngClass]="className"
    [class.has-icon-left]="iconType"
    [class.has-icon-right]="iconTypeRight || (isClearBtnShown && clearIcon)"
    [class.error-msg-shown]="(hasError && errorMsg) || (hasError && errors)"
  >
    <input
      #inputElement
      [id]="name"
      [attr.e2e-attr]="e2eAttrs.INPUT_COMPONENT_INPUT_ELEMENT"
      [attr.maxlength]="maxLength"
      [name]="name"
      [type]="fieldType"
      class="x_input"
      [ngClass]="className"
      [disabled]="disabled"
      [required]="required"
      [readonly]="readonly"
      [pattern]="pattern"
      [placeholder]="placeholder"
      [class.error]="hasError"
      [ngModel]="value"
      (input)="onInputHandler($event)"
      (focus)="onFocusHandler()"
      (focusout)="onFocusOutHandler($event)"
      (blur)="onBlurHandler()"
      virtualKeyboard
      [isVirtualKeyboardShown]="false"
    />
    @if (iconType) {
      <i [ngClass]="iconType" class="x_input-icon icon-left"></i>
    }
    @if (iconTypeRight) {
      <i [ngClass]="iconTypeRight" class="x_input-icon icon-right"></i>
    }
    @if (isClearBtnShown && clearIcon) {
      <i
        [ngClass]="clearIcon"
        class="x_input-icon icon-right"
        [attr.e2e-attr]="e2eAttrs.SEARCH_CLEAR"
        (click)="onClearClick()"
      ></i>
    }
    @if (hasError && errorMsg) {
      <div class="x_input-error-msg">
        {{ errorMsg }}
      </div>
    }
    @if (hasError && errors) {
      <div class="x_input-error-msg">
        {{ errorText }}
      </div>
    }
  </div>
</div>
